/** Brain 1-op-1 (opdracht Frank 25 oktober 2026): wat de sync met de vault deed, als zin in de Postbus.
 *  Puur, zodat elke soort op uitkomst te toetsen is. De backend schrijft `inhoud.vault` in
 *  `services/vaultorde.py`; de zinnen staan hier, zodat ze de taal van de app volgen. */
export const VAULTORDE = "vaultorde";

const ZINNEN = {
  project: "De map {map} in je vault is nu het project {project}, met de kennisbank {bank}.",
  losse: "De {aantal} losse bestanden in je vault, buiten een map, staan nu in de kennisbank Losse bestanden in het project {project}.",
  gevolgd: "De map {map} heet nu {nieuw}. De kennisbank {bank} volgt hem; er is niets opnieuw ingelezen.",
  onder: "De map {map} staat nu in {nieuw}, en die valt al onder de kennisbank van {onder}. De kennisbank {bank} houdt zijn oude stukken tot jij beslist.",
  verdwenen: "De map {map} staat niet meer in je vault. De kennisbank {bank} blijft staan met wat hij had; weggooien doe jij.",
  verwijderd: "Deze bestanden staan niet meer in je vault en zijn uit hun kennisbank gehaald:",
  niet_ingelezen: "Deze bestanden in je vault zijn niet ingelezen, met de reden:",
  // Vondst Frank 27 okt 2026: het bericht draagt alleen nog wat er veranderde (`vaultorde.wat_te_melden`).
  niet_ingelezen_bij: "Er kwamen {nieuw} bestanden bij die niet zijn ingelezen, met de reden. Het volledige overzicht staat onder Kennis, bij Niet ingelezen.",
  niet_ingelezen_minder: "Er zijn {minder} bestanden minder die niet zijn ingelezen, en er kwam niets bij. Het volledige overzicht staat onder Kennis, bij Niet ingelezen.",
};

/** De zin bij een vaultbericht als [sleutel, waarden], of null voor een onbekende soort. */
export function zinVan(vault) {
  const zin = vault && ZINNEN[vault.soort];
  return zin ? [zin, vault] : null;
}

const VASTE_REDENEN = ["verborgen bestand", "slotbestand van Word", "dubbel met markdown",
  "zelfde naam als een ander los bestand"];

/** Een reden uit de backend als [sleutel, waarden]: de vaste woorden vertaald, een soort of fout erachter. */
export function redenVan(reden) {
  const r = reden || "";
  if (VASTE_REDENEN.includes(r)) return [r, {}];
  let m = r.match(/^soort (.+)$/);
  // GL204-1: "(geen)" is een vast woord van de backend en geen extensie; het volgt de taal.
  if (m && m[1] === "(geen)") return ["soort zonder extensie", {}];
  if (m) return ["soort {soort}", { soort: m[1] }];
  m = r.match(/^overgeslagen map \((.+)\)$/);
  if (m) return ["overgeslagen map ({map})", { map: m[1] }];
  m = r.match(/^inlezen mislukt: (.*)$/);
  if (m) return ["inlezen mislukt: {fout}", { fout: m[1] }];
  return ["{reden}", { reden: r }];
}

/** GL204-1 (glasronde 0.9.204): de mapnaam in een vaultbericht als [sleutel, waarden]. Een echte map
 *  blijft zoals hij in de vault heet; alleen het vaste label van de backend voor de losse bestanden
 *  bovenin de vault (`vaultorde._rij`) is een woord van NovaMund en volgt de taal van de app. */
export const LOSSE_RIJ = "(losse bestanden in de vault)";
export function mapVan(map) {
  return map === LOSSE_RIJ ? [LOSSE_RIJ, {}] : ["{map}", { map: map || "" }];
}

const KOP = /^(Nieuw project|Map hernoemd|Map verplaatst|Map verdwenen|Nieuwe kennisbank): (.+)$/;
const KOP_AANTAL = /^(Uit de vault verwijderd|Niet ingelezen): (\d+) bestanden$/;

/** De kop van een vaultbericht als [sleutel, waarden], of null. */
export function kopVanVault(titel) {
  let m = (titel || "").match(KOP);
  if (m) return [`${m[1]}: {naam}`, { naam: m[2] }];
  m = (titel || "").match(KOP_AANTAL);
  if (m) return [`${m[1]}: {n} bestanden`, { n: m[2] }];
  return null;
}

/** Elke sleutel die hierboven als tekst ontstaat. `taal-dekking` ziet alleen letterlijke `t("...")`,
 *  dus deze lijst heeft een eigen dekkingstoets (vaultorde.test.js). */
export const SLEUTELS = [
  ...Object.values(ZINNEN), ...VASTE_REDENEN,
  "soort {soort}", "overgeslagen map ({map})", "inlezen mislukt: {fout}",
  "Nieuw project: {naam}", "Map hernoemd: {naam}", "Map verplaatst: {naam}", "Map verdwenen: {naam}",
  "Nieuwe kennisbank: {naam}", "Uit de vault verwijderd: {n} bestanden", "Niet ingelezen: {n} bestanden",
  "{map}: {aantal} keer {reden}", "en nog {n}", LOSSE_RIJ, "soort zonder extensie",
  "Overgeslagen mappen, niet meegeteld: {aantal} bestanden in {mappen}",
];
